import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PageHeader, StatusBadge, fmtDateTime, EmptyState } from "@/components/shared";
import { FileText, FileDown, RotateCcw } from "lucide-react";

export default function MyDocuments() {
  const [docs, setDocs] = useState([]);

  useEffect(() => { api.get("/my/documents").then(({ data }) => setDocs(data)); }, []);

  const openPdf = async (id, kind) => {
    try {
      const { data } = await api.get(`/assignments/${id}/${kind}`, { responseType: "blob" });
      window.open(URL.createObjectURL(data), "_blank");
    } catch { toast.error("Impossibile aprire il verbale"); }
  };

  return (
    <div>
      <PageHeader eyebrow="Archivio" title="I miei documenti" subtitle="Verbali di consegna e riconsegna firmati" />

      {docs.length ? (
        <div className="space-y-3">
          {docs.map((d) => (
            <Card key={d.id} data-testid={`my-doc-${d.id}`} className="p-4 sm:p-5 rounded-lg flex items-center justify-between gap-4">
              <div className="flex items-center gap-4 min-w-0">
                <div className="h-11 w-11 rounded-md bg-primary/10 flex items-center justify-center shrink-0">
                  <FileText className="h-5 w-5 text-primary" />
                </div>
                <div className="min-w-0">
                  <div className="font-semibold truncate">{d.asset_names}</div>
                  <div className="text-xs text-muted-foreground">
                    {d.asset_count} bene/i · Consegna {fmtDateTime(d.assigned_date)}
                    {d.returned_date ? ` · Riconsegna ${fmtDateTime(d.returned_date)}` : ""}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0 flex-wrap justify-end">
                <div className="hidden sm:block"><StatusBadge status={d.status} /></div>
                <Button variant="outline" size="sm" onClick={() => openPdf(d.id, "pdf")} data-testid={`download-doc-${d.id}`}>
                  <FileDown className="h-4 w-4 sm:mr-1.5" /> <span className="hidden sm:inline">Consegna</span>
                </Button>
                {d.has_return && (
                  <Button variant="outline" size="sm" onClick={() => openPdf(d.id, "return-pdf")} data-testid={`download-return-${d.id}`}>
                    <RotateCcw className="h-4 w-4 sm:mr-1.5" /> <span className="hidden sm:inline">Restituzione</span>
                  </Button>
                )}
              </div>
            </Card>
          ))}
        </div>
      ) : (
        <Card className="rounded-lg"><EmptyState icon={FileText} title="Nessun documento" subtitle="I verbali che firmi appariranno qui." /></Card>
      )}
    </div>
  );
}
